import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImageRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 28.395 28.395",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Bilde_til_h\\xF8yre",
		"data-name": "Bilde til h\\xF8yre",
		transform: "translate(-544.107 -2049.154)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "format_image_left_FILL0_wght300_GRAD0_opsz48",
			d: "M158.4,254.4v-1.841H130V254.4Zm0-6.35V232.335H142.685v15.711Zm0-20.2V226H130v1.841ZM156.555,246.2H144.526V234.176h12.029Zm-18.223,1.544v-1.841H130v1.841h8.331Zm0-6.631v-1.841H130v1.841h8.331Zm0-6.646v-1.841H130v1.841h8.331Z",
			transform: "translate(414.105 1823.153)"
		}), /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_649",
			"data-name": "Rectangle 649",
			width: 14,
			height: 14,
			transform: "translate(557.5 2055.853)"
		})]
	})
});
export default SvgImageRight;
